import React from 'react';
import { Link, useLocation } from 'react-router-dom';

function Sidebar() {
  const location = useLocation();

  const menuItems = [
    { path: '/dashboard', label: 'Dashboard' },
    { path: '/exhibitor-directory', label: 'Exhibitor Directory' },
    { path: '/exhibitor-badges', label: 'Exhibitor Badges' },
    { path: '/electronic-surveillance', label: 'Electronic Surveillance CCTV' },
    { path: '/safe-rental', label: 'Safe Rental / Safe key Person' },
    { path: '/stand-cleaning', label: 'Stand Cleaning Services (Housekeeping)' },
    { path: '/host-hostesses', label: 'Host Hostesses' },
    { path: '/exhibitor-branding', label: 'Exhibitor Branding' },
    { path: '/stall-layout', label: 'Stall Layout/Furniture Exchange' },
    { path: '/extra-furniture', label: 'Extra Furniture' },
    { path: '/stall-allotment', label: 'Stall Allotment Letter' },
    { path: '/sponsorship-opportunities', label: 'Sponsorship Opportunities' },
  ];

  return (
    <div className="sidebar">
      <ul>
        {menuItems.map((item) => (
          <li
            key={item.path}
            className={location.pathname === item.path ? 'active' : ''}
          >
            <Link to={item.path}>{item.label}</Link>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Sidebar;
